/**
 * @generated SignedSource<<2977cadd8f63cd029c4c91a9a6ef197b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BookmarkKind = "brain_search" | "comment" | "content_usage" | "occurrence" | "post" | "%future added value";
export type CreateBookmarkInput = {
  brainSearchId?: string | null;
  contentId?: string | null;
  contentUsageId?: string | null;
  kind: BookmarkKind;
  organizationId?: string | null;
};
export type BookmarkButtonCreateMutation$variables = {
  input: CreateBookmarkInput;
};
export type BookmarkButtonCreateMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly brainSearch: {
        readonly hasViewerBookmarked: boolean;
        readonly id: string;
      } | null;
      readonly content: {
        readonly hasViewerBookmarked: boolean;
        readonly id: string;
      } | null;
      readonly contentUsage: {
        readonly hasViewerBookmarked: boolean;
        readonly id: string;
      } | null;
      readonly id: string;
    } | null;
  };
};
export type BookmarkButtonCreateMutation = {
  response: BookmarkButtonCreateMutation$data;
  variables: BookmarkButtonCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasViewerBookmarked",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBookmarkResponse",
    "kind": "LinkedField",
    "name": "createBookmark",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Bookmark",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "contentUsage",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrainSearch",
            "kind": "LinkedField",
            "name": "brainSearch",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookmarkButtonCreateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookmarkButtonCreateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "435e8ca26afa3edf42af58e4f5d990a9",
    "id": null,
    "metadata": {},
    "name": "BookmarkButtonCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BookmarkButtonCreateMutation(\n  $input: CreateBookmarkInput!\n) {\n  response: createBookmark(input: $input) {\n    node {\n      id\n      content {\n        id\n        hasViewerBookmarked\n      }\n      contentUsage {\n        id\n        hasViewerBookmarked\n      }\n      brainSearch {\n        id\n        hasViewerBookmarked\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "df9750b43195e31aaa30328383a2270b";

export default node;
